export default __webpack_public_path__ + "static/media/ojos-rasgados-marron.2583de6d.png";